import React from 'react';
import styled from 'styled-components';

import { Col, Separator, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Column = styled(Col)`
  margin-bottom: 24px;
`;

const Title = styled(Text)`
  border-bottom: 2px solid;
  width: max-content;
  text-transform: capitalize;
`;

const MAP = {
  is_enrolled: 'Enrolled',
  consumed_referral: 'Referral Consumed',
  country_code: 'Country Code',
  enrollment_type: 'Enrollment Type',
  has_renewed: 'Renewed',
  paid_within_campaign: 'Fee Paid Under Same Campaign',
  false: 'No',
  true: 'Yes',
};

const ReferralQualifyingCriteria = ({ qualifyingCriteria }) => {
  return (
    <>
      {Object.entries(qualifyingCriteria)?.map(([key, value]) => {
        return (
          <Column key={key}>
            <Title variant="h4">{key}</Title>
            <Separator height={16} transparent />
            {Object.entries(value)?.map(([k, v]) => {
              return (
                <Row gap={12} justifyContent="space-between" alignItems="center">
                  <Text variant="eyebrow2">{MAP[k] || k}</Text>
                  <Text variant="h6">{MAP[v] || v}</Text>
                </Row>
              );
            })}
          </Column>
        );
      })}
    </>
  );
};

export default ReferralQualifyingCriteria;
